<script lang="ts">
	import { getContext } from "svelte";
	import { twMerge } from "tailwind-merge";
	import type { Suite } from "#gen/bundles/v1/bundle_pb.js";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import type { AssetLoad } from "#lib/api/bundles.js";
	import TokenizedImage from "#lib/components/TokenizedImage.svelte";
	import type { ModuleItemProps } from "#lib/components/flow/viewer/types.js";
	import { getAssetRef, getIconUrl } from "#lib/components/flow/viewer/utils.js";
	import type { TokenProvider } from "#lib/tokenProvider.js";
	import type { Writable } from "svelte/store";

	const tokenProvider: Writable<TokenProvider> = getContext("tokenProvider");
	const suite: Writable<Suite> = getContext("suite");
	const assets: Writable<Record<string, AssetLoad>> = getContext("assets");
	const { module, mode, classes, onShow, onEdit }: ModuleItemProps = $props();

	const ref = $derived(getAssetRef($suite, module));
	const iconUrl = $derived(getIconUrl($assets, module.key, ref, mode));

	function handleEdit() {
		const asset = $assets[module.key];
		if (asset) {
			onEdit?.(asset);
		}
	}

	function handleShow() {
		onShow?.(module);
	}
</script>

<button data-flow-button type="button" onclick={mode === Mode.EDITING ? handleEdit : handleShow} class={twMerge("flex h-39.75 w-full flex-col overflow-hidden rounded-2xl bg-white p-0", classes.borderClass, classes.outlineClass, classes.readOnlyClass)} class:!opacity-50={ref?.disabled}>
	<div class="relative flex w-full grow items-center justify-center">
		<TokenizedImage provider={$tokenProvider} src={iconUrl} {mode} />
	</div>
</button>
